<template>
    <div style="overflow-wrap: anywhere;">
        <p>
            Nyní, prosím, vložte klíč naší služby do své schránky. Tuto možnost najdete na
            <a class="underline" href="https://www.mojedatovaschranka.cz/portal/ISDS/nastaveni/extapp/spiscert">https://www.mojedatovaschranka.cz/portal/ISDS/nastaveni/extapp/spiscert</a>
            <img src="/img/hspis1.png" alt="guide">
        </p>

        <p class="mt-4">
            Klíč (zkopírujete kliknutím): <br>
            <code @click="copyPubKey" :class="copying ? 'text-blue-500' : 'text-black'" class="bg-gray-50 p-1 font-bold cursor-pointer transition-colors">
                {{ pubkey }}
            </code>
        </p>
    </div>
</template>

<script>
export default {
    name: "HspisPopupFirst",
    data(){
        return {
            copying: false,
            pubkey: this.$page.props.hspisPublicKey
        }
    },
    methods: {
        copyPubKey(){
            this.copying = true;
            setTimeout( () => { this.copying = false; }, 250);
            navigator.clipboard.writeText(this.pubkey);
        }
    }
}
</script>

<style scoped>

</style>
